import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { missingOffers, resolveBusinessProfile } from '../../core/helpers/business-profile'
import { OfferCard, OfferTitle, OfferText, OfferLink, TypeBadge, TypeLabel } from './business-styled'

// Тип бизнеса в самом верху меню: человек сразу видит, какой набор у него
// включён, и не гадает, почему нет «парка» или «мастерской»
export const BusinessType = () => {
  const capabilities = useSelector((state) => state.capabilities)
  const profile = resolveBusinessProfile(capabilities)
  if (!profile) return null

  return (
    <TypeLabel>
      Тип: <TypeBadge>{profile.name}</TypeBadge>
    </TypeLabel>
  )
}

// Что в SmartPark есть, а здесь не подключено. Подключение - через «Подписку»:
// там уже написано, как сменить тариф
export const OffersCard = () => {
  const navigate = useNavigate()
  const capabilities = useSelector((state) => state.capabilities)
  const offers = missingOffers(capabilities)
  if (!offers.length) return null

  return (
    <OfferCard>
      <OfferTitle>Что ещё есть в SmartPark</OfferTitle>
      {offers.map((offer) => (
        <div key={offer.key}>
          <strong>{offer.title}</strong>
          <OfferText>{offer.text}</OfferText>
        </div>
      ))}
      <OfferLink type="button" onClick={() => navigate('/settings/subscription')}>
        Как подключить
      </OfferLink>
    </OfferCard>
  )
}
